// Rego and Log server
export const DEFAULT_REGO_SERVER_URL = 'm3.fleetway.io:8788';
export const DEFAULT_LOG_SERVER_URL =
    process.env.REACT_APP_LOCAL_ENV === 'prod' ? 'htrv.fleetway.io:5141' : 'ssl.fleetway.io:5141';
